import { Component, Input } from '@angular/core';
import { IsActiveMatchOptions } from '@angular/router';

interface IMatList {
  name: string;
  icon: string;
  active: boolean;
  id: string[];
  lines: number;
  secondaryText: string;
}

@Component({
    selector: 'myt-services-card',
    templateUrl: './services-card.component.html',
    styleUrl: './services-card.component.scss',
    standalone: false
})
export class ServicesCardComponent {
  readonly myMatchOptions: IsActiveMatchOptions = {
    queryParams: 'ignored',
    matrixParams: 'exact',
    paths: 'exact',
    fragment: 'exact',
  };
  activeIndexOfNavItems = 0;

  @Input() individualNavItems: IMatList[] = [];

  @Input() businessNavItems: IMatList[] = [];

  setActiveNavItem(index: number) {
    this.individualNavItems[this.activeIndexOfNavItems].active = false;
    this.activeIndexOfNavItems = index;
  }
}
